import { render, staticRenderFns } from "./labelItem.vue?vue&type=template&id=1ffd81f4&scoped=true&"
import script from "./labelItem.vue?vue&type=script&lang=js&"
export * from "./labelItem.vue?vue&type=script&lang=js&"
import style0 from "./labelItem.vue?vue&type=style&index=0&id=1ffd81f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd81f4",
  null
  
)

export default component.exports